import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgActionOutput = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M13 19h2l-3 3.5L9 19h2v-9h2v9Zm9-2h-6v-2h4V4H4v11h4v2H2V2h20v15Z"
    />
  </svg>
);
export default SvgActionOutput;
